import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SignIn as SignInWidget } from '../../../components/Authentication/widgets/SignIn.js';
export const CheckoutSignIn = () => {
  return _jsx(SignInWidget, {
    variant: "checkoutSignIn"
  });
};